<div
  *ngIf="block"
  class="container-page-general position-relative d-flex flex-column justify-content-end align-items-center"
>
  <div
    *ngIf="!isSecondLevelUp"
    class="container-page-general__title w-100 text-center"
  >
    <h1
      *ngIf="titlePage"
      class="ls-h1-page-title text-brand-10 text-start text-lg-center px-3 px-lg-0 mb-4"
      [innerHTML]="titlePage"
    ></h1>
    <p
      class="container ls-p text-neutral-40 text-start text-lg-center"
      *ngIf="block.field_sottotitolo"
      [innerHTML]="block.field_sottotitolo"
      style="margin: 12px 0"
    ></p>
  </div>
  <div class="d-flex w-100 bg-neutral-95 container container-header-evento">
    <div class="col-6">
      <!-- ARCHIVIO EVENTO -->
      <ng-container *ngIf="node.type[0].target_id === 'archivio_evento'">
        <p
          class="m-0 text-uppercase text-support-40 ls-label-small-bold padding-b-16"
        >
          {{ "CONTENT_TYPES.PAGE_EVENTO.WHEN" | translate }}
        </p>
        <div class="padding-b-16" *ngIf="startEvent === endEvent">
          <p class="text-neutral-30 ls-p m-0">
            {{ "CONTENT_TYPES.PAGE_EVENTO.BY" | translate }}
          </p>
          <p
            class="text-uppercase text-garamond text-neutral-30 ls-label-xl-large m-0"
          >
            {{ startEvent | localizedDate : "dd MMM YY" }}
          </p>
        </div>
        <div class="padding-b-16" *ngIf="startEvent && startEvent !== endEvent">
          <p class="text-neutral-30 ls-p m-0">
            {{ "CONTENT_TYPES.PAGE_EVENTO.FROM" | translate }}
          </p>
          <p
            class="text-uppercase text-garamond text-neutral-30 ls-label-xl-large m-0"
          >
            {{ startEvent | localizedDate : "dd MMM YY" }}
          </p>
        </div>
        <div class="padding-b-16" *ngIf="startEvent !== endEvent && endEvent">
          <p class="text-neutral-30 ls-p m-0">
            {{ "CONTENT_TYPES.PAGE_EVENTO.TO" | translate }}
          </p>
          <p
            class="text-uppercase text-garamond text-neutral-30 ls-label-xl-large m-0"
          >
            {{ endEvent | localizedDate : "dd MMM YY" }}
          </p>
        </div>
      </ng-container>
      <!-- END ARCHIVIO EVENTO -->
      <!-- IN PRESENZA -->
      <ng-container *ngIf="block.field_tipologia_evento === 'In presenza'">
        <p
          class="m-0 text-uppercase text-support-40 ls-label-small-bold padding-b-16"
        >
          {{ "CONTENT_TYPES.PAGE_EVENTO.WHEN" | translate }}
        </p>
        <div class="padding-b-16" *ngIf="startEvent === endEvent">
          <p *ngIf="startEvent !== endEvent" class="text-neutral-30 ls-p m-0">
            {{ "CONTENT_TYPES.PAGE_EVENTO.BY" | translate }}
          </p>
          <p
            class="text-uppercase text-garamond text-neutral-30 ls-label-xl-large m-0"
          >
            {{ startEvent | localizedDate : "dd MMM YY" }}
          </p>
        </div>
        <div class="padding-b-16" *ngIf="startEvent && startEvent !== endEvent">
          <p class="text-neutral-30 ls-p m-0">
            {{ "CONTENT_TYPES.PAGE_EVENTO.FROM" | translate }}
          </p>
          <p
            class="text-uppercase text-garamond text-neutral-30 ls-label-xl-large m-0"
          >
            {{ startEvent | localizedDate : "dd MMM YY" }}
          </p>
        </div>
        <div class="padding-b-16" *ngIf="startEvent !== endEvent && endEvent">
          <p class="text-neutral-30 ls-p m-0">
            {{ "CONTENT_TYPES.PAGE_EVENTO.TO" | translate }}
          </p>
          <p
            class="text-uppercase text-garamond text-neutral-30 ls-label-xl-large m-0"
          >
            {{ endEvent | localizedDate : "dd MMM YY" }}
          </p>
        </div>
        <div class="padding-b-32">
          <p class="text-neutral-30 ls-p m-0">
            <span
              *ngIf="
                block.field_orario_inizio && block.field_orario_inizio.trim()
              "
              >{{ "CONTENT_TYPES.PAGE_EVENTO.FROM_HOUR" | translate }}
              {{ block.field_orario_inizio }}</span
            >
            <span
              *ngIf="block.field_orario_fine && block.field_orario_fine.trim()"
              >{{ "CONTENT_TYPES.PAGE_EVENTO.TO_HOUR" | translate }}
              {{ block.field_orario_fine }}</span
            >
          </p>
        </div>
        <div>
          <a
            *ngIf="
              block.field_link_iscrizione && stringToDate(endEvent) >= today
            "
            class="btn btn-custom text-uppercase ls-label-medium"
            target="_blank"
            [href]="block.field_link_iscrizione"
            >{{
              "CONTENT_TYPES.PAGE_EVENTO.SUBSCRIBE_TO_THE_EVENT" | translate
            }}
          </a>
        </div>
      </ng-container>
      <!-- END IN PRESENZA -->
      <!-- ONLINE -->
      <ng-container *ngIf="block.field_tipologia_evento === 'Online'">
        <p
          class="m-0 text-uppercase text-support-40 ls-label-small-bold padding-b-16"
        >
          {{ "CONTENT_TYPES.PAGE_EVENTO.WHEN" | translate }}
        </p>
        <p
          class="text-uppercase text-garamond text-neutral-30 ls-label-xl-large m-0 padding-b-16"
        >
          {{ startEvent | localizedDate : "dd MMM YY" }}
        </p>
        <div [ngClass]="{ 'padding-b-80': false }">
          <p class="text-neutral-30 ls-p m-0">
            <span
              *ngIf="
                block.field_orario_inizio && block.field_orario_inizio.trim()
              "
              >{{ "CONTENT_TYPES.PAGE_EVENTO.FROM_HOUR" | translate }}
              {{ block.field_orario_inizio }}</span
            >
            <span
              *ngIf="block.field_orario_fine && block.field_orario_fine.trim()"
              >{{ "CONTENT_TYPES.PAGE_EVENTO.TO_HOUR" | translate }}
              {{ block.field_orario_fine }}</span
            >
          </p>
        </div>
        <div>
          <a
            *ngIf="
              block.field_link_iscrizione && stringToDate(endEvent) >= today
            "
            class="btn btn-custom text-uppercase ls-label-medium"
            target="_blank"
            style="margin-top: 32px"
            [href]="block.field_link_iscrizione"
            >{{
              "CONTENT_TYPES.PAGE_EVENTO.SUBSCRIBE_TO_THE_EVENT" | translate
            }}</a
          >
        </div>
      </ng-container>
      <!-- END ONLINE -->
      <!-- ONLINE E IN PRESENZA -->
      <ng-container
        *ngIf="block.field_tipologia_evento === 'In presenza/Online'"
      >
        <p
          class="m-0 text-uppercase text-support-40 ls-label-small-bold padding-b-16"
        >
          {{ "CONTENT_TYPES.PAGE_EVENTO.WHEN" | translate }}
        </p>
        <div class="padding-b-16" *ngIf="startEvent === endEvent">
          <p *ngIf="startEvent !== endEvent" class="text-neutral-30 ls-p m-0">
            {{ "CONTENT_TYPES.PAGE_EVENTO.BY" | translate }}
          </p>
          <p
            class="text-uppercase text-garamond text-neutral-30 ls-label-xl-large m-0"
          >
            {{ startEvent | localizedDate : "dd MMM YY" }}
          </p>
        </div>
        <div class="padding-b-16" *ngIf="startEvent && startEvent !== endEvent">
          <p class="text-neutral-30 ls-p m-0">
            {{ "CONTENT_TYPES.PAGE_EVENTO.FROM" | translate }}
          </p>
          <p
            class="text-uppercase text-garamond text-neutral-30 ls-label-xl-large m-0"
          >
            {{ startEvent | localizedDate : "dd MMM YY" }}
          </p>
        </div>
        <div class="padding-b-16" *ngIf="startEvent !== endEvent && endEvent">
          <p class="text-neutral-30 ls-p m-0">
            {{ "CONTENT_TYPES.PAGE_EVENTO.TO" | translate }}
          </p>
          <p
            class="text-uppercase text-garamond text-neutral-30 ls-label-xl-large m-0"
          >
            {{ endEvent | localizedDate : "dd MMM YY" }}
          </p>
        </div>
        <div class="padding-b-32">
          <p class="text-neutral-30 ls-p m-0">
            <span
              *ngIf="
                block.field_orario_inizio && block.field_orario_inizio.trim()
              "
              >{{ "CONTENT_TYPES.PAGE_EVENTO.FROM_HOUR" | translate }}
              {{ block.field_orario_inizio }}</span
            >
            <span
              *ngIf="block.field_orario_fine && block.field_orario_fine.trim()"
              >{{ "CONTENT_TYPES.PAGE_EVENTO.TO_HOUR" | translate }}
              {{ block.field_orario_fine }}</span
            >
          </p>
        </div>
        <div>
          <a
            *ngIf="
              block.field_link_iscrizione && stringToDate(endEvent) >= today
            "
            class="btn btn-custom text-uppercase ls-label-medium"
            target="_blank"
            [href]="block.field_link_iscrizione"
            >{{
              "CONTENT_TYPES.PAGE_EVENTO.SUBSCRIBE_TO_THE_EVENT" | translate
            }}
          </a>
        </div>
      </ng-container>
      <!-- END ONLINE E IN PRESENZA -->
    </div>
    <div class="col-6">
      <!-- ARCHIVIO EVENTO -->
      <ng-container
        *ngIf="
          node.type[0].target_id === 'archivio_evento' &&
          block.field_dati_evento &&
          block.field_dati_evento.length
        "
      >
        <p
          class="m-0 text-uppercase text-support-40 ls-label-small-bold padding-b-40"
        >
          {{ "CONTENT_TYPES.PAGE_EVENTO.EVENT_DATA" | translate }}
        </p>
        <div>
          <p
            class="text-neutral-30 ls-p m-0"
            [innerHTML]="block.field_dati_evento[0].value"
          ></p>
        </div>
      </ng-container>
      <!-- END ARCHIVIO EVENTO -->
      <!-- IN PRESENZA -->
      <ng-container *ngIf="block.field_tipologia_evento === 'In presenza'">
        <p
          class="m-0 text-uppercase text-support-40 ls-label-small-bold padding-b-40"
        >
          {{ "CONTENT_TYPES.PAGE_EVENTO.PRESENCE" | translate }}
        </p>
        <div>
          <p
            class="text-neutral-30 ls-p-semibold padding-b-16"
            [innerHTML]="block.field_nome_location"
          ></p>
          <p
            class="text-neutral-30 ls-p m-0 padding-b-40"
            style="max-width: 230px"
            [innerHTML]="block.field_indirizzo_location"
          ></p>
          <a
            *ngIf="block.field_link_mappa"
            [href]="block.field_link_mappa"
            target="_blank"
          >
            <p
              class="text-uppercase cursor-pointer ls-label-medium-semibold text-brand-40"
            >
              {{ "CONTENT_TYPES.PAGE_EVENTO.SHOW_MAP" | translate }}
            </p>
          </a>
        </div>
      </ng-container>
      <!-- END IN PRESENZA -->
      <!-- ONLINE -->
      <ng-container *ngIf="block.field_tipologia_evento === 'Online'">
        <p
          class="m-0 text-uppercase text-support-40 ls-label-small-bold padding-b-16"
          [ngClass]="{ 'padding-b-24': true }"
        >
          {{ "CONTENT_TYPES.PAGE_EVENTO.ONLINE" | translate }}
        </p>
        <p
          *ngIf="!block.field_testo_cta_meet_online"
          class="text-neutral-30 ls-p-semibold m-0 padding-b-16"
          [ngClass]="{ 'padding-b-24': true }"
        >
          {{ "CONTENT_TYPES.PAGE_EVENTO.GOOGLE_MEET" | translate }}
        </p>
        <p
          *ngIf="
            block.field_testo_cta_meet_online && stringToDate(endEvent) >= today
          "
          class="text-neutral-30 ls-p-semibold m-0 padding-b-16"
          [ngClass]="{ 'padding-b-24': true }"
          [innerHTML]="block.field_testo_cta_meet_online"
        ></p>
        <!-- <p *ngIf="block.field_link_meet_online" class="text-neutral-30 ls-p m-0 padding-b-16">
                    {{"CONTENT_TYPES.PAGE_EVENTO.LINK_FOR_VIRTUAL_ROOM" | translate}}</p> -->
        <a
          *ngIf="
            block.field_link_meet_online && stringToDate(endEvent) >= today
          "
          [href]="block.field_link_meet_online"
          target="_blank"
        >
          <p class="text-uppercase text-brand-40 ls-label-small-semibold">
            {{ "CONTENT_TYPES.PAGE_EVENTO.JOIN_TO_THE_EVENT" | translate }}
          </p>
        </a>
      </ng-container>
      <!-- END ONLINE -->
      <!-- ONLINE E IN PRESENZA -->
      <ng-container
        *ngIf="block.field_tipologia_evento === 'In presenza/Online'"
      >
        <p
          class="m-0 text-uppercase text-support-40 ls-label-small-bold padding-b-40"
        >
          {{ "CONTENT_TYPES.PAGE_EVENTO.PRESENCE_ONLINE" | translate }}
        </p>
        <div>
          <p
            class="text-neutral-30 ls-p-semibold"
            [innerHTML]="block.field_nome_location"
          ></p>
          <p
            class="text-neutral-30 ls-p mb-3"
            style="max-width: 230px"
            [innerHTML]="block.field_indirizzo_location"
          ></p>
          <a
            *ngIf="block.field_link_mappa"
            [href]="block.field_link_mappa"
            target="_blank"
          >
            <p
              class="text-uppercase cursor-pointer ls-label-medium-semibold text-brand-40"
            >
              {{ "CONTENT_TYPES.PAGE_EVENTO.SHOW_MAP" | translate }}
            </p>
          </a>
        </div>
        <!-- END IN PRESENZA -->
        <!-- ONLINE -->
        <p
          *ngIf="!block.field_testo_cta_meet_online"
          class="text-neutral-30 ls-p-semibold m-0 padding-b-16 mt-4"
          [ngClass]="{ 'padding-b-24': true }"
        >
          {{ "CONTENT_TYPES.PAGE_EVENTO.GOOGLE_MEET" | translate }}
        </p>
        <p
          *ngIf="
            block.field_testo_cta_meet_online && stringToDate(endEvent) >= today
          "
          class="text-neutral-30 ls-p-semibold m-0 padding-b-16"
          [ngClass]="{
            'padding-b-24': true,
            'mt-3': block.field_testo_cta_meet_online
          }"
          [innerHTML]="block.field_testo_cta_meet_online"
        ></p>
        <!-- <p *ngIf="block.field_link_meet_online" class="text-neutral-30 ls-p m-0 padding-b-16">
                                {{"CONTENT_TYPES.PAGE_EVENTO.LINK_FOR_VIRTUAL_ROOM" | translate}}</p> -->
        <a
          *ngIf="
            block.field_link_meet_online && stringToDate(endEvent) >= today
          "
          [href]="block.field_link_meet_online"
          target="_blank"
        >
          <p class="text-uppercase text-brand-40 ls-label-medium-semibold">
            {{ "CONTENT_TYPES.PAGE_EVENTO.JOIN_TO_THE_EVENT" | translate }}
          </p>
        </a>
      </ng-container>
      <!-- END ONLINE E IN PRESENZA -->
    </div>
  </div>
  <div class="container p-0 container-img">
    <img
      loading="lazy"
      *ngIf="block.field_immagine"
      [src]="imgPath"
      [alt]="imgAlt"
    />
    <img
      loading="lazy"
      *ngIf="
        block.field_immagine_importata && block.field_immagine_importata.length
      "
      [src]="block.field_immagine_importata[0].url"
      [alt]="block.field_immagine_importata[0].alt"
    />
  </div>
</div>
<ng-container *ngIf="node && block && isSpinner; else spinner">
  <!-- <div *ngIf="isSecondLevelUp" class="container-field-taxonomies"> -->
  <div
    *ngIf="node.type[0].target_id !== 'archivio_evento'"
    class="container-field-taxonomies"
  >
    <!-- DEFAULT PAGINA FIELD -->
    <app-container-field-taxonomies
      [dataFieldTaxonomies]="dataFieldTaxonomies"
      [typeOfContent]="'evento'"
    >
    </app-container-field-taxonomies>
    <!-- END DEFAULT PAGINA FIELD -->
  </div>
  <!-- Anchor -->
  <app-sample-anchor
    *ngIf="anchorItems && !isSecondLevelUp"
    [anchorItems]="anchorItems"
    [idAnchor]="idAnchor"
    [positionType]="'mt-2'"
    [bgColor]="'white'"
    [setOffset]="120"
    [positionTop]="'120px'"
    [styleHeader]="'second'"
  >
  </app-sample-anchor>
  <!-- END Anchor -->
  <!-- HEADER COLLAPSE -->
  <div
    *ngIf="block && node"
    id="collapse"
    [ngClass]="{
      'opacity-100 visible bg-neutral-A1': isCollapseHeader,
      'opacity-0 invisible bg-neutral-99': !isCollapseHeader
    }"
    class="container-page-general-collapse position-fixed no-print"
  >
    <div
      class="container-page-general-collapse__item text-md-center d-flex justify-content-between align-items-center border-bottom-custom"
    >
      <div
        *ngIf="isShowLocalMenu"
        class="d-flex align-items-end container-icon-expand m-auto col-1"
      >
        <img
          loading="lazy"
          *ngIf="isSecondLevelUp"
          class="cursor-pointer hidden-phone"
          src="../../../../../../assets/images/side-menu-expand.svg"
          alt="menu expand"
          style="margin-left: 34px"
          (click)="openMenu()"
        />
      </div>
      <p
        *ngIf="titlePage"
        class="ls-h1-page-title-collapse col-10 mb-1"
        [ngClass]="{ 'offset-md-1': !isShowLocalMenu }"
        [innerHTML]="titlePage"
      ></p>
      <div
        class="d-flex justify-content-end align-items-center col-1"
        [ngClass]="{
          'col-1': titlePage && isShowLocalMenu,
          'col-11': !titlePage && isShowLocalMenu,
          'col-12': !titlePage && !isShowLocalMenu
        }"
      >
        <div class="cursor-pointer" (click)="nodeService.openModaleShare()">
          <img
            loading="lazy"
            src="../../../../../../assets/images/share-icon/share-icon-yellow.png"
            alt="share icon"
            style="margin-right: 34px"
          />
        </div>
      </div>
    </div>
    <div
      *ngIf="!isSecondLevelUp && anchorItems.length"
      class="border-bottom-custom"
      style="padding: 16px 10px"
    >
      <app-sample-anchor
        *ngIf="anchorItems"
        [anchorItems]="anchorItems"
        [styleHeader]="'collapse'"
        [positionTop]="'140px'"
        [bgColor]="'transparent'"
        [setOffset]="120"
      >
      </app-sample-anchor>
    </div>
  </div>
  <!-- END HEADER COLLAPSE -->
  <div
    *ngIf="block.field_descrizione"
    class="container container-description mt-5"
    [innerHTML]="block.field_descrizione"
  ></div>
  <div
    *ngIf="block.field_testo_formattato"
    class="container container-description-archivio mt-5"
    [innerHTML]="
      nodeService.modifyLinks(
        node.field_testo_formattato[0].value,
        domainWebsite
      ) | safeHtml
    "
  ></div>
  <div
    *ngIf="block.field_corpo_testo"
    class="container container-corpo-testo overflow-hidden mt-5"
    [innerHTML]="
      nodeService.modifyLinks(block.field_corpo_testo, domainWebsite)
    "
  ></div>
  <ng-container
    *ngIf="node.field_layout_righe && node.field_layout_righe.length"
  >
    <div class="container-row">
      <div *ngFor="let row of node.field_layout_righe; let idx = index">
        <app-row
          [lang]="node.langcode[0].value"
          [rowId]="row.target_id"
          [position]="idx"
          [attr.rowid]="row.target_id"
          [preview]="node.preview"
          (objAnchor)="addNewAnchorItem($event)"
        >
        </app-row>
      </div>
    </div>
  </ng-container>
  <div
    *ngIf="node.created[0].value"
    class="mt-5 mb-5 d-flex flex-wrap justify-content-between w-100 container container-published"
    style="gap: 20px 0"
  >
    <div class="col-12 col-sm-8 order-1 ordder-sm-0">
      <div class="d-flex w-100 mb-2">
        <p class="text-neutral-30 ls-label-medium-semibold mb-0 me-1">
          {{ "CONTENT_TYPES.CONTENT_PUBLISHED" | translate }}
        </p>
        <p class="text-neutral-30 ls-label-medium-semibold mb-0">
          {{ node.created[0].value | localizedDate : "dd MMMM yyyy - HH:MM" }}
        </p>
      </div>
      <div class="d-flex w-100" *ngIf="node.changed[0].value">
        <p class="text-neutral-30 ls-p-small mb-0 me-1">
          {{ "CONTENT_TYPES.LAST_MODIFIED" | translate }}
        </p>
        <p class="text-neutral-30 ls-p-small mb-0">
          {{ node.changed[0].value | localizedDate : "dd MMMM yyyy - HH:MM" }}
        </p>
      </div>
    </div>
    <div
      class="container-page-general__container-share cursor-pointer col-12 col-sm-4 col-md-3 order-0 order-sm-1"
      (mouseenter)="onHoverShare = true"
      (mouseleave)="onHoverShare = false"
      (click)="nodeService.openModaleShare()"
    >
      <p class="m-0 ls-label-medium-semibold text-uppercase">
        {{ "MODAL_SHARE.SEND_TO" | translate }}
      </p>
      <img
        loading="lazy"
        src="../../../../../../assets/images/share-icon/share-icon-yellow.png"
        alt="share icon"
      />
    </div>
  </div>
  <div
    *ngIf="node.field_oggetto_view && relatedEvents && relatedEvents.length"
    class="container-view"
  >
    <app-sample-view-content-related
      [oggetto_view]="'eventi'"
      [relatedData]="relatedEvents"
    ></app-sample-view-content-related>
  </div>
</ng-container>
<ng-template #spinner>
  <app-spinner></app-spinner>
</ng-template>
